(function(){

	SUGApp.service('siteSearchService', ['SUGUtilities', function(util) {

		var service = {};

		service.getSearchResults = function(data){
			return util.APISyncCall("post", "", data, "c.siteSearchResults", 15000);
		};

		return service;
	}]);


}());
